module.exports = __webpack_public_path__ + "static/media/051.6201fa45.jpg";